var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.to ? "router-link" : "a",
    _vm._g(
      {
        tag: "component",
        staticClass: "_btn",
        class: _vm._class,
        style: { width: _vm.width, height: _vm.height },
        attrs: {
          href: _vm.href,
          to: _vm.to,
          id: _vm.id,
          inert: _vm.inert,
          tabindex: _vm.inert ? -1 : _vm.tabindex,
        },
      },
      _vm.__on
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }